import persistReducer from 'redux-persist/es/persistReducer';
import storage from 'redux-persist/lib/storage';
import { registerParentsReducer } from '../Slices/registerParents.slice';
const registerParentPersistConfig = {
  key: 'register-parent',
  version: 1,
  storage,
};

export const persistedRegisterParents = persistReducer(
  registerParentPersistConfig,
  registerParentsReducer
);
